import { useReduxState } from 'hooks';
import Router from 'next/router';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';
import { Box } from 'components/common/box';

const AchievementDelete = () => {
  const {
    messages,
    pageState: { achievement },
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const deleteAchievement = async (values?: { deletionReason?: string }) => {
    let url = `/admin/achievements/${achievement.id}`;

    if (values?.deletionReason) {
      const params = new URLSearchParams({
        deletionReason: values.deletionReason
      });
      url += `?${params.toString()}`;
    }

    await api.delete(url);
    Router.push('/achievements');

    return true;
  };

  return (
    <div className="delete">
      <Box title={messages.commonDelete}>
        {requireReasonWhenDeletingData ? (
          <ConfirmDeleteButton
            buttonText={messages.achievementDelete}
            confirmText={messages.achievementDeleteConfirm}
            confirmTitle={messages.achievementDelete}
            id="deletionReasonAchievement"
            onConfirm={deleteAchievement}
            successMessage={messages.achievementDeleteSuccess}
          />
        ) : (
          <ConfirmButton
            actionText={messages.commonDelete}
            buttonIcon="trash-alt"
            buttonText={messages.achievementDelete}
            category="danger"
            confirmText={messages.achievementDeleteConfirm}
            confirmTitle={messages.achievementDelete}
            onConfirm={deleteAchievement}
            successMessage={messages.achievementDeleteSuccess}
          />
        )}
      </Box>
    </div>
  );
};

export default AchievementDelete;
